import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createRouter, createWebHistory } from 'vue-router'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCanadianMapleLeaf, faFacebook, faInstagram, faYoutube, faXTwitter, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faFlagUsa } from '@fortawesome/free-solid-svg-icons';
import NewsLetter from './components/NewsLetters.vue';
import StockPhotos from './components/StockPhotos.vue';
import StockVideos from './components/StockVideos.vue';
import VideoScripts from './components/VideoScripts.vue';
import Captions from './components/PostCaptions.vue';
import PinkDoor from './components/PinkDoor.vue';
import StealReel from './components/StealReel.vue';
import DFYReel from './components/DFYReel.vue';

// import VueTour from 'vue-tour';
import 'vue-tour/dist/vue-tour.css';
import LeadMagnets from './components/LeadMagnets.vue'

library.add(faCanadianMapleLeaf, faFlagUsa, faFacebook, faYoutube, faInstagram, faXTwitter, faTiktok);
loadFonts()

const routes = [
  { path: '/', component: PinkDoor, name: 'Home' }, 
  { path: '/newsletters', component: NewsLetter, name: 'Newsletters' },
  { path: '/photos', component: StockPhotos, name: 'Stock Photos' }, 
  { path: '/videos', component: StockVideos, name: 'Stock Videos' }, 
  { path: '/magnets', component: LeadMagnets, name: 'Lead Magnets' }, 
  { path: '/reels', component: StealReel, name: 'Reels' }, 
  { path: '/dfy-reels', component: DFYReel, name: 'DFY Reels' }, 
  { path: '/scripts', component: VideoScripts, name: 'Scripts' },
  { path: '/captions', component: Captions, name: 'Captions' }, 
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});


const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(vuetify);
app.use(router)
// app.use(VueTour);
app.mount('#app');

